var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7598_3775)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5998 1.03304C12.8224 0.01346 11.173 0.554284 11.173 1.82875V3.10848C8.65823 3.07871 6.93793 3.94315 5.79203 5.15036C4.56706 6.44087 4.06322 8.05427 3.85208 9.15747C3.74652 9.709 4.10832 10.1092 4.48854 10.2474C4.85178 10.3794 5.33716 10.3229 5.66107 9.9526C6.5804 8.9018 8.3665 7.4352 11.173 7.53093V9.17127C11.173 10.4457 12.8224 10.9865 13.5998 9.96693L16.0957 6.69356C16.635 5.98627 16.635 5.01373 16.0957 4.30644L13.5998 1.03304ZM5.48817 8.23967C6.69164 7.1894 8.41916 6.20379 11.173 6.20379H11.8473C12.2196 6.20379 12.5214 6.50069 12.5214 6.86691L12.5213 9.17127L15.0171 5.89785C15.1969 5.66209 15.1969 5.33791 15.0171 5.10215L12.5213 1.82875V3.77159C12.5213 4.1378 12.2195 4.43467 11.8472 4.43467H11.173C8.1397 4.43467 6.77747 6.05543 6.77747 6.05543C6.15032 6.71612 5.74672 7.50133 5.48817 8.23967Z",
    fill: "#8968D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1665 1.16928H3.1665C2.06194 1.16928 1.1665 2.06471 1.1665 3.16928V13.8359C1.1665 14.9405 2.06194 15.8359 3.1665 15.8359H13.8332C14.9378 15.8359 15.8332 14.9405 15.8332 13.8359V11.8359C15.8332 11.4677 15.5347 11.1693 15.1665 11.1693C14.7983 11.1693 14.4998 11.4677 14.4998 11.8359V13.8359C14.4998 14.2041 14.2014 14.5026 13.8332 14.5026H3.1665C2.79832 14.5026 2.49984 14.2041 2.49984 13.8359V3.16928C2.49984 2.80109 2.79832 2.50261 3.1665 2.50261H5.1665C5.53469 2.50261 5.83317 2.20413 5.83317 1.83595C5.83317 1.46775 5.53469 1.16928 5.1665 1.16928Z",
    fill: "#8968D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7598_3775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.c27c764376b94ce8d786dc2c63cc13eb.svg";
export { ForwardRef as ReactComponent };